module.exports = __webpack_public_path__ + "img/global background.6d09d1a7.jpeg";